import TalentNotFoundFeedbackForm from './TalentNotFoundFeedbackForm';

export default TalentNotFoundFeedbackForm;
